import styled, { CSSProperties } from 'styled-components';
import C from '@assets/themes/colors';
interface IRootProps {
    isSelected?: boolean;
    fromImage?: boolean;
  }
  interface IColorRectProps {
    hasOneColorCloseToWhite: boolean;
}

interface IColorSectionProps {
    hasOneColorCloseToWhite: boolean;
    backgroundColor?: string;
    first?: boolean;
    last?: boolean;
}

export const SliderRail: CSSProperties = {
  height: 1,
  background: "#818181",
}

export const SliderHandle: CSSProperties = {
  height: 10,
  width: 10,
  marginTop: -4,
  backgroundColor: "#c4c4c4",
  border: 0
}

export const SliderTrack: CSSProperties = {
  height: 1,
  background: "none",
}

export const SliderDot: CSSProperties = {
  border: 0,
  height: 5,
  width: 5,
  top: -2,
  background: "#c4c4c4",
}

  export const Root = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    padding: 0px 0px;
  `;

export const optionContainer = styled.div`
  display:flex;
  flex-direction:row;  
  align-items: center;
  margin-top:10px;
  width:100%;
`;


export const Label = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin: 6px 5px 10px 5px;
  min-width: 95px;
`;

export const SliderContainer = styled.div`
  display:flex;  
  width:100%;
  margin:10px;
`;


export const ButtonContainer = styled.div`
  display:flex;
  margin-left: auto;
  margin-right: auto;
  width: 45px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  //background-color: #122442;
  background-color: ${(props: IRootProps) => props.isSelected ? "#122442" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${(props: IRootProps) => props.fromImage ? C.DARK_BLUE : C.GRAY}
    }
`;

export const OptionsList = styled.div`
  width: 313px;
  height: auto;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  z-index: 51;
  margin-top: 16px;
  padding: 14px 19.5px;
  flex-direction:column; 
`;

export const InputSlider = styled.input
`
  width: 40px;
  height: 18px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  background-color: var(--white);
  text-align: center;
  margin:10px;
  outline: none;
`;


export const ButtonOption = styled.div`
  display: flex;
  width: 44px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: ${(props: IRootProps) => props.isSelected ? "rgba(18, 36, 66, 0.1);" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;



export const ControlContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 14px 0px 0px 0px;
    align-items: center;
`;

export const ColorContainer = styled.div`
    width: 100%;
`;

export const ColorRect = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: auto; 
    margin-right: 16px;
    width: ${(props: IColorRectProps) =>  props.hasOneColorCloseToWhite ? "32px" : "30px" };
    height: 30px;
    cursor: pointer;
`;

export const ColorSection = styled.div`
    height: 30px;
    width: 100%;
    background-color: ${(props: IColorSectionProps) => props.backgroundColor ?? "#000000"};
    border-top-left-radius: ${(props: IColorSectionProps) => props.first ? "5px":""};
    border-bottom-left-radius: ${(props: IColorSectionProps) => props.first ? "5px":""};
    border-top-right-radius: ${(props: IColorSectionProps) => props.last ? "5px":""};
    border-bottom-right-radius: ${(props: IColorSectionProps) => props.last ? "5px":""};
    border-top: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite ? "solid 2px #ccc" : "solid 0px" };
    border-bottom: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite ? "solid 2px #ccc" : "solid 0px" };
    border-left: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite && props.first ? "solid 2px #ccc" : "solid 0px" };
    border-right: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite && props.last ? "solid 2px #ccc" : "solid 0px" };
`;

export const LabelTitle = styled.span`
    margin: 3px 23px 3px 0;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
`;

export const PickerContainer = styled.div`
    width: 100%;
    display: flex;
    height: auto;
    flex-direction: column;
    flex-grow: 0;
    margin: 10px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    border: solid 1px #ccc;
`;

export const ColorSpacer = styled.div`
    margin: 0px 0px 0px 3px;
    
`;